// Context: https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from "@sentry/nextjs";

import { sentryDataCollection } from "./lib/sentry-data-collection";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn,
  enabled: !!dsn,
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV ?? "unset",
  ...sentryDataCollection,
  integrations: [Sentry.replayIntegration({ stickySession: true })],
  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: parseFloat(
    process.env.NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? "0",
  ),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
